import { FieldConfig } from '../utils'

export const NAME: FieldConfig<unknown> = {
  type: 'string',
  label: 'Name',
  ariaLabel: 'Name',
  name: 'name',
  required: true,
  placeholder: 'E.g. 100 USD',
}

export const CONVERSIONS_VALUE = (name: string, label: string): FieldConfig<unknown> => ({
  type: 'number',
  min: 0,
  step: 0.01,
  label,
  ariaLabel: label,
  name: `${name}.value`,
  required: true,
})
